module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "sidenav-new"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.active,
      "unique-opened": true,
      "default-openeds": _vm.opened,
      "collapse": _vm.bodyWidth < 1280
    }
  }, _vm._l((_vm.menus), function(menu, idx) {
    return _c('div', {
      key: idx
    }, [(menu.children) ? _c('div', [(!_vm.checkSCM(menu)) ? _c('el-submenu', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), (menu.hasNewPoint === true) ? _c('el-badge', {
      staticClass: "item px-badge",
      attrs: {
        "is-dot": ""
      }
    }, [_c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])]) : _c('span', {
      staticClass: "menu-name"
    }, [_vm._v(_vm._s(menu.name))])], 1), _vm._v(" "), _vm._l((menu.children), function(child, idx) {
      return [((_vm.checkMenuAuthority(child))) ? _c('div', {
        key: idx,
        class: child.className ? child.className : null
      }, [((child.path && child.path !== '/Member/MemberTransfer') || (child.path === '/Member/MemberTransfer' && !_vm.crmUpdateClose)) ? _c('el-menu-item', {
        attrs: {
          "index": ("" + (child.id))
        },
        on: {
          "click": function($event) {
            _vm.jump(child, menu)
          }
        }
      }, [(child.hasNewPoint) ? _c('el-badge', {
        staticClass: "item px-badge",
        attrs: {
          "value": "NEW"
        }
      }, [_vm._v("\n                  " + _vm._s(child.name) + "\n                ")]) : _c('span', [_vm._v(_vm._s(child.name))])], 1) : (child.oldPath) ? _c('a', {
        attrs: {
          "href": _vm.ctx + _vm.getMenuPath(child.oldPath)
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": child.id
        }
      }, [_vm._v(_vm._s(child.name))])], 1) : _vm._e()], 1) : _vm._e()]
    })], 2) : _vm._e()], 1) : _c('div', [(menu.path) ? _c('router-link', {
      attrs: {
        "to": menu.path
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": ("" + (menu.id))
      }
    }, [_c('i', {
      class: ("iconfont " + (menu.icon))
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-name",
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(menu.name))])])], 1) : _c('a', {
      attrs: {
        "href": _vm.ctx + _vm.getMenuPath(menu.oldPath)
      }
    }, [_c('el-menu-item', {
      attrs: {
        "index": menu.id
      }
    }, [_c('i', {
      class: 'iconfont ' + menu.icon
    }), _vm._v("\n            " + _vm._s(menu.name) + "\n          ")])], 1)], 1)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e06340a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/SideNav/SideNavCRM.vue
// module id = 748
// module chunks = 8